export const NetworkContextName = 'NETWORK'
